import { breakpoints } from '@/styles/theme/constants';
import { useMediaQuery } from '@chakra-ui/react';
import { useMemo } from 'react';

const useResponsive = () => {
  const [isMobile] = useMediaQuery(`(max-width: ${breakpoints['768px']})`);
  const [isMobileIframe] = useMediaQuery(`(max-width: 889px})`);
  const [isMaxWidth768px] = useMediaQuery(
    `(max-width: ${breakpoints['768px']})`
  );
  const [isMaxWidth414px] = useMediaQuery(
    `(max-width: ${breakpoints['414px']})`
  );
  const [isMaxWidth320px] = useMediaQuery(
    `(max-width: ${breakpoints['320px']})`
  );
  const [isMaxHeight414px] = useMediaQuery(
    `(max-height: ${breakpoints['414px']})`
  );
  const [isMaxHeight576px] = useMediaQuery(
    `(max-height: ${breakpoints['576px']})`
  );
  return useMemo(
    () => ({
      isMobile,
      isMaxWidth768px,
      isMaxWidth414px,
      isMaxWidth320px,
      isMaxHeight414px,
      isMaxHeight576px,
      isMobileIframe,
    }),
    [
      isMobile,
      isMaxWidth768px,
      isMaxWidth414px,
      isMaxWidth320px,
      isMaxHeight414px,
      isMaxHeight576px,
      isMobileIframe,
    ]
  );
};

export default useResponsive;
